(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  const slidesContainer = document.querySelector('.announcement-bar__slides');
  if (slidesContainer) {
    const slides = Array.from(slidesContainer.children);
    let scrollAmount = 0;
    const speed = 1; // Ajusta la velocidad del scroll

    // Clonar todo el contenido para efecto infinito
    const slidesClone = slides.map(slide => slide.cloneNode(true));
    slidesClone.forEach(clone => slidesContainer.appendChild(clone));

    // Calcular ancho total de los slides originales
    const totalWidth = slides.reduce((sum, slide) => sum + slide.offsetWidth + parseInt(getComputedStyle(slide).marginRight || 0), 0);

    function animate() {
      scrollAmount += speed;
      if (scrollAmount >= totalWidth) {
        scrollAmount = 0; // Reinicia scroll para efecto infinito
      }
      slidesContainer.style.transform = `translateX(-${scrollAmount}px)`;
      requestAnimationFrame(animate);
    }

    animate();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
